export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SmallSlider.vue?vue&type=template&id=1856219c&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/SmallSlider.vue?vue&type=template&id=1856219c&scoped=true&
// module id = 138
// module chunks = 0